import { useState } from 'react'
import { FormInstance } from 'antd'
import { DeliverySubscription } from '../../../types/deliverySubscription/DeliverySubscription'
import { DeliverySubscriptionFormData } from '../types'

export const useSubscriptionFormState = (form: FormInstance<DeliverySubscriptionFormData>) => {
  const [open, setOpen] = useState(false)
  const [deliverySubscription, setDeliverySubscription] = useState<DeliverySubscription>()

  const handleClose = () => {
    form.resetFields()
    setOpen(false)
    setDeliverySubscription(undefined)
  }

  const openForEdit = (sub: DeliverySubscription) => {
    setDeliverySubscription(sub)
    setOpen(true)
  }

  const openForCreate = () => setOpen(true)

  return { open, deliverySubscription, handleClose, openForEdit, openForCreate }
}
